export default __webpack_public_path__ + "static/media/1975.c17aab29.png";